import { useLang } from "../LanguageContext";
import { translations } from "../data/translations";
import { motion } from "framer-motion";
import { Layers } from "lucide-react";
import { rackRailsProducts } from "../data/rackRailsProducts";
import ProductCard from "./ProductCard";

export default function RackRailsSection() {
  const { lang } = useLang();
  const t = translations[lang];

  return (
    <section id="rack-rails" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mb-4">
            <Layers className="w-10 h-10 text-brand-blue" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-3">
            {t.rackRails?.title || "Rack Rails & Zubehör"}
          </h2>

          <p className="text-gray-600 max-w-2xl mx-auto mb-4">
            {t.rackRails?.subtitle || "Originales Chenbro Rack-Zubehör"}
          </p>

          <p className="text-gray-500 max-w-xl mx-auto">
            {t.rackRails?.description || "Schienensätze, Rackmount Rails und passendes Zubehör"}
          </p>
        </motion.div>

        <div className="text-center mb-6 text-sm text-gray-500">
          {rackRailsProducts.length}{" "}
          {rackRailsProducts.length === 1
            ? (t.products?.resultSingle || "Produkt")
            : (t.products?.results || "Produkte")}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {rackRailsProducts.map((product, idx) => (
            <ProductCard key={product.id} product={product} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
